<template>
  <div class="row">
    <div class="col-12">
      <div
        class="navbar-light border-bottom border-white"
        :class="{ 'bg-light': $window.CONTEXT === 'production', 'bg-info': $window.CONTEXT === 'stage' }"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-4 col-md-8">
              <nav class="d-print-none navbar navbar-expand-lg">
                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav me-auto mb-2 mb-lg-0" v-if="isAuthenticated">
                    <li class="nav-item">
                      <router-link :to="{ name: 'Home' }" class="nav-link" active-class="active">Domov</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])">
                      <router-link :to="{ name: 'Calls' }" class="nav-link" active-class="active">Klici</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Customer'])">
                      <router-link :to="{ name: 'Service' }" class="nav-link" active-class="active"
                        >Servisni</router-link
                      >
                    </li>

                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Customer'])">
                      <router-link :to="{ name: 'ServiceOrdersMap' }" class="nav-link" active-class="active"
                        >🚩</router-link
                      >
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'LeaderService'])">
                      <router-link :to="{ name: 'Calendar' }" class="nav-link" active-class="active">📅</router-link>
                    </li>

                    <li
                      class="nav-item"
                      v-if="
                        $hasRole(role, ['Administrator']) ||
                        $hasRoleEndsWith(role, ['Projects']) ||
                        $hasRoleStartsWith(role, ['Leader'])
                      "
                    >
                      <router-link :to="{ name: 'Projects' }" class="nav-link" active-class="active"
                        >Projekti</router-link
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="
                        $hasRole(role, ['Administrator', 'WarehouseManager']) ||
                        $hasRoleEndsWith(role, ['Production']) ||
                        $hasRoleStartsWith(role, ['Leader'])
                      "
                    >
                      <router-link :to="{ name: 'Production' }" class="nav-link" active-class="active"
                        >Proizvodni</router-link
                      >
                    </li>
                    <li
                      class="nav-item"
                      v-if="$hasRole(role, ['Administrator']) || $hasRoleStartsWith(role, ['Leader'])"
                    >
                      <router-link :to="{ name: 'Offers' }" class="nav-link" active-class="active">Ponudbe</router-link>
                    </li>
                    <li class="nav-item" v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Warehouse'])">
                      <router-link :to="{ name: 'WarehouseTransfers' }" class="nav-link" active-class="active">
                        <strong v-if="!worker.activeWarehouse.value?.isPrimary">{{
                          worker.activeWarehouse.value?.name || "Medskladiščnice"
                        }}</strong
                        ><span v-else>{{ worker.activeWarehouse.value?.name || "Medskladiščnice" }}</span>
                      </router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="!$hasRole(role, ['WorkerSubcontractor', 'Customer'])">
                      <a
                        class="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdownMenuLink"
                        role="button"
                        data-bs-toggle="dropdown"
                      >
                        Šifranti
                      </a>
                      <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                        <li>
                          <router-link
                            :to="{ name: 'Workers' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Delavci</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Customers' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRole(role, ['Administrator'])"
                            >Stranke</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Users' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRole(role, ['Administrator'])"
                            >Uporabniki</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Warehouses' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Skladišča</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Facilities' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Objekti</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Devices' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Naprave</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Materials' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker'])"
                            >Material</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'BomTemplates' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >BOM predloge</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'Commissions' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Komisioni</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            :to="{ name: 'ServiceOrdersWithCompletedMovementsCard' }"
                            class="dropdown-item"
                            active-class="active"
                            v-if="$hasRoleStartsWith(role, ['Admin', 'Leader'])"
                            >Premiki materiala</router-link
                          >
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item" v-if="$hasRole(role, ['Customer'])">
                      <router-link :to="{ name: 'Facilities' }" class="nav-link" active-class="active"
                        >Objekti</router-link
                      >
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div class="col-8 col-md-4">
              <div class="d-flex justify-content-end align-items-center mt-2">
                <button
                  v-if="$hasRoleStartsWith(role, ['Admin', 'Leader', 'Worker', 'Warehouse'])"
                  class="btn btn-sm btn-info me-2"
                  type="button"
                  @click="$router.push({ name: 'InternalOrder', params: { workOrderId: 'new' } })"
                >
                  Int.nalog
                </button>
                <Pause v-if="isAuthenticated" class="me-2" />
                <span class="navbar-text d-none d-xl-inline" v-show="!!user?.name">{{ user?.name }}</span>
                <SignInOutButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Notification />
  <ModalAssignWorkOrder
    :visible="!!assignTarget"
    :orderForAssignment="assignTarget"
    @close="closeAssign"
    @assigned="finishAssign"
  />
  <div v-if="!state.errors.value.length && !worker.workPauseStartDateTime.value" class="mt-2">
    <div v-if="currentCustomerId">
      <router-view />
    </div>
    <div v-else-if="worker.isLoaded.value && worker.activeWarehouse.value">
      <router-view v-if="currentWorkerId" />
    </div>
    <div v-else-if="worker.isLoaded.value && currentWorkerId">
      <SelectWarehouse cssClass="row col mt-3 p-3 bg-info rounded" />
    </div>
    <div v-else class="p-5 mb-4 bg-light rounded-3">
      <div class="container-fluid py-5" v-show="!state.loading.value">
        <h1 class="display-5 fw-bold">Niste prijavljeni</h1>
        <p class="col-md-8 fs-4">Prosim prijavite se s klikom na gumb desno zgoraj.</p>
      </div>
    </div>
  </div>

  <pre v-show="false">
  {{ authState }}
  </pre>
</template>

<script setup>
import { computed, provide, onUnmounted } from "vue"

import {
  useAuth,
  authState,
  isAuthenticated,
  user,
  role,
  currentWorkerId,
  currentCustomerId,
} from "./composition-api/useAuth"
import { useWorker } from "./composition-api/useWorker"
import SignInOutButton from "./components/SignInOutButton.vue"
import Notification from "./components/Notification.vue"
import { setError, setWarning, useNotification } from "./components/Notification"
import ModalAssignWorkOrder from "./components/ModalAssignWorkOrder.vue"
import { assignTarget, closeAssign, finishAssign } from "./components/AssignWorkOrder"
import Pause from "./components/Pause.vue"
import SelectWarehouse from "./components/SelectWarehouse.vue"

defineOptions({ name: "App" })

const { worker } = useWorker()
const { state } = useNotification()

const getLocationAsync = (options = {}) => {
  return new Promise((resolve, reject) => {
    if ((!"geolocation") in window.navigator) {
      console.error("no browser support for geolocation")
      reject("no browser support")
    } else {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            altitude: position.coords.altitude,
            altitudeAccuracy: position.coords.altitudeAccuracy,
            accuracy: position.coords.accuracy,
          })
        },
        (e) => {
          console.warn("getCurrentPosition error", e)
          setWarning(e.message)
          resolve(null)
          //reject(e.message)
        },
        options,
      )
    }
  })
}

provide("getLocationAsync", getLocationAsync)
provide("hasLocationPermissions", "geolocation" in window.navigator)
</script>
